module.exports = __webpack_public_path__ + "img/triangle-bottom_hover.96d9e6f2.png";